import React from "react";
import Contact from "../../components/Contact/index";
import Breadcrumb from "../../components/Breadcrumb";
import CTA from "../../components/CTA";

import bgImg from "../../assets/img/cta/cta-bg.png";

const ContactMain = () => {
  return (
    <main>
      <Breadcrumb
        pageTitle="Contact"
        description="Get in touch with PRD Infotech for expert technology solutions, IT consulting, and digital transformation services. Whether you have a question, need assistance, or want to explore business opportunities, our team is here to help. Reach out today, and let’s work together to create innovative, scalable, and future-ready solutions that drive growth and success."
      />

      <Contact />

      <CTA
        ctaBG={bgImg}
        Title="Have Questions? We're Here to Help!"
        Description="Our team at PRD Infotech is ready to assist you. Reach out today to learn how our innovative software solutions can drive your business forward."
      />
    </main>
  );
};

export default ContactMain;
